module.exports = __webpack_public_path__ + "img/App Elements.a7c45db0.png";